// Flat translation dictionary keyed by "section.key". Add new keys here and
// call t('section.key') anywhere via the useLanguage() hook — components
// don't need any other setup. Currently covers the always-visible chrome
// (nav, hero, stats bar, footer); extend page by page as needed.
export const translations = {
  'nav.home': { en: 'Home', es: 'Inicio' },
  'nav.services': { en: 'Services', es: 'Servicios' },
  'nav.learnMore': { en: 'Learn More', es: 'Más Información' },
  'nav.about': { en: 'About', es: 'Nosotros' },
  'nav.contact': { en: 'Contact', es: 'Contacto' },
  'nav.getQuote': { en: 'Get a Quote', es: 'Solicitar Cotización' },

  'hero.eyebrow': {
    en: 'Industrial Consulting · Continuous Improvement',
    es: 'Consultoría Industrial · Mejora Continua',
  },
  'hero.title': {
    en: 'Solving Problems From Their Root Cause',
    es: 'Resolviendo Problemas Desde su Causa Raíz',
  },
  'hero.tagline': {
    en: 'PSI helps organizations identify not just what failed, but why it failed and how to build the intelligence to prevent it.',
    es: 'PSI ayuda a las organizaciones a identificar no solo qué falló, sino por qué falló y cómo construir la inteligencia para prevenirlo.',
  },
  'hero.ctaPrimary': { en: 'Request a Quote', es: 'Solicitar Cotización' },
  'hero.ctaSecondary': { en: 'View Services', es: 'Ver Servicios' },

  'stats.years.value': { en: '20+', es: '20+' },
  'stats.years.label': { en: 'Years of Experience', es: 'Años de Experiencia' },
  'stats.bilingual.value': { en: 'EN / ES', es: 'EN / ES' },
  'stats.bilingual.label': { en: 'Bilingual', es: 'Bilingüe' },
  'stats.formats.value': { en: 'On-site · Online · Hybrid', es: 'Presencial · En Línea · Híbrido' },
  'stats.formats.label': { en: 'Delivery Formats', es: 'Formatos de Entrega' },
  'stats.availability.value': {
    en: 'PSI goes wherever solutions are needed',
    es: 'PSI llega donde se necesiten soluciones',
  },
  'stats.availability.label': { en: 'Availability', es: 'Disponibilidad' },

  'footer.copyright': {
    en: '© 2026 Problem Solving Intelligence. All rights reserved.',
    es: '© 2026 Problem Solving Intelligence. Todos los derechos reservados.',
  },
  'footer.tagline': {
    en: 'Enjoying Solving Problems Effectively',
    es: 'Disfrutando Resolver Problemas Eficazmente',
  },
};
